import { IPriceListViewModel } from "./I4UViewModels";
import { FixedTermDurationUnit } from "./CommonEnums";
import * as moment from "moment-recent";

require("core-js/features/array/find-index");

export interface INotificationUtils {
    showBlockingMessage(message: string): void,
    hideBlockingMessage(): void,
    showInfoMessage(message): void,
    showInfoMessageWithExpiration(message, expirationTime: number): void,
    showErrorMessage(message): void
}

export class NotificationUtils  implements INotificationUtils{
    showBlockingMessage(message: string): void {
        $.blockUI({
            message: "<h4 id='blocking-message'>" + message + "</h4>",
            css: {
                border: 'none',
                padding: '15px',
                backgroundColor: '#000',
                '-webkit-border-radius': '10px',
                '-moz-border-radius': '10px',
                opacity: .5,
                color: '#fff',
                'z-index': 2011
            },
            overlayCSS: {
                'z-index': 2000
            }
        });
    }
    hideBlockingMessage(): void {
        $.unblockUI();
    }
    showInfoMessage(message): void {
        var $expTime = this.__setExpireTimeByMessageLength(message);
        var $container = this.__getContainer();
        var opts = { expires: $expTime };
        $container.notify("create", {
            text: message
        }, opts);
    }

    showInfoMessageWithExpiration(message, expirationTime: number): void {
        var $container = this.__getContainer();
        var opts = { expires: expirationTime };
        $container.notify("create", {
            text: message
        }, opts);
    }
    showErrorMessage(message): void {
        var $expTime = this.__setExpireTimeByMessageLength(message);
        var $container = this.__getContainer();
        var opts = { expires: $expTime };
        $container.notify("create", "basic-error-template", {
            text: message
        }, opts);
    }
    private __getContainer(): JQuery {
        var id = "__notifications";
        var $container = $("#" + id);
        if ($container.length == 0) {
            $container = $("<div id='" + id + "' style='display: none; z-index: 2000;'>" +
                "<div id='basic-template'>" +
                "<a class='ui-notify-cross ui-notify-close' href='#'>x</a>" +
                "<h1>#{text}</h1>" +
                "</div>" +
                "<div id='basic-titled-template'>" +
                "<a class='ui-notify-cross ui-notify-close' href='#'>x</a>" +
                "<h1>#{title}</h1>" +
                "<p>#{text}</p>" +
                "</div>" +
                "<div id='basic-error-template' style=''>" +
                "<a class='ui-notify-cross ui-notify-close' href='#'>x</a>" +
                "<div style='float: left; margin: 0 8px 0 0; color: red;'><i class='icon-ban-circle icon-3x'></i></div>" +
                "<h1>#{title}</h1>" +
                "<p>#{text}</p>" +
                "</div>" +
                "</div>");

            $("body").append($container);
            $container = $("#" + id);
            $container.notify();

        }
        return $container;
    }
    private __setExpireTimeByMessageLength(msg: string): number {
        var expTime = 5000;
        if (msg != null && msg.length > 60) {
            expTime += parseInt("" + ((msg.length - 60) / 30 + 1), 10) * 1000;
        }
        return expTime;
    }
}

export class ArrayUtils {
    static findAll(arr: any, cond: (item) => boolean): any[] {
        let count = arr.length;
        let result = [];
        for (let i = 0; i < count; ++i) {
            let item = arr[i];
            if (cond(item))
                result.push(item);
        }
        return result;
    }
}

export class ObjectUtils {
    static isAllSet(...args: any[]): boolean {
        let ndx = args.findIndex(x => x == null || x.toString().length == 0);
        return ndx == -1;
    }
    static isSet(arg: any) {
        return arg != null && arg.toString().length != 0;
    }
    static isSetNonZero(arg: any) {
        if (typeof arg === "number")
            return this.isSet(arg) && arg !== 0;
        else
            return this.isSet(arg);
    }
}

export class DurationFormatUtils {
    static formatDuration(priceList: IPriceListViewModel, locale: string = "fi"): string {
        if (!priceList.FixedTerm) {
            if (locale === "fi") {
                return "Toistaiseksi";
            }
            else if (locale === "sv") {
                return " Tillsvidare";
            }
        }

        const duration = priceList.FixedTermDuration;
        const durationUnit = priceList.FixedTermDurationUnit;

        let str = "" + duration + " ";
        switch (durationUnit) {
            case FixedTermDurationUnit.DAYS:
                if (locale === "fi") {
                    str += duration === 1 ? "päivä" : "päivää";
                }
                else if (locale === "sv") {
                    str += duration === 1 ? "dag" : "dagar";
                }
                break;
            case FixedTermDurationUnit.MONTHS:
                if (locale === "fi") {
                    str += duration === 1 ? "kuukausi" : "kuukautta";
                }
                else if (locale == "sv") {
                    str += duration === 1 ? "månad" : "månader";
                }
                break;
            case FixedTermDurationUnit.YEARS:
                if (locale === "fi") {
                    str += duration === 1 ? "vuosi" : "vuotta";
                }
                else if (locale === "sv") {
                    str += duration === 1 ? "år" : "år";
                }
                break;
        }
        return str;
    }

    static formatDate(date: string) {
        return moment(date).format("DD.MM.YYYY");
    }
}
